import { AppThunk } from '../../../../store/types';
import { setAddVideoConfirmAction } from '../../../../store/general/actions';
import { YoutubeUrlUtil } from '../../../../../common/utils/youtube-url-util';
import { getAddVideoConfirm } from '../../../../store/general/selectors';
import { addVideoEffect, TAddVideoResult } from '../../../../effects/video_effects';
import { Navigator } from '../../../../effects/navigator';
import {
	createGroupNameIndex,
	getActiveGroupId,
	getGroupNativeLanguage,
	getGroupTargetLanguage,
	getNativeLanguage,
	getTargetLanguage,
	getUserGroupById
} from '../../../../store/models/selectors';
import { UserGroupEffects } from '../../../../effects/userGroupEffects';
import { VideoMetaInfo } from '../../../../../common/utils/videoMetaInfo';
import { LangUtil } from '../../../../../common/utils/lang-util';
import { ErrorEffects } from '../../../../effects/errorEffects';
import { EUserGroupType } from '../../../../store/general/types';
import { EventsRouter } from '../../../../../common/events/eventsRouter';
import { Events } from '../../../../../common/events/types';
import { AuthUserEffects } from '../../../../effects/authUserEffects';
import { LoginPopupSelectors } from '../../../../store/loginPopup/selectors';
import { copyPhrasesRest } from '../../../../../common/rest/video/copyPhrasesRest';
import { removeVideoFromGroup } from '../../../../effects/phrase/phraseVocabularyEffect';

export class AddVideoConfirmEvents {

	public static onChange(
		groupId: number,
		newListName?: string,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const state = getState();
			const {
				videoId,
				videoLangCodes = [],
				videoInfo,
				srcGroupId
			} = getAddVideoConfirm(state) || {};
			if (!videoId) {
				dispatch(this.onClose());
				return Promise.reject();
			}

			try {
				if (!groupId) { // create group

					let userTargetLang = getTargetLanguage(state)?.code || '';
					let userNativeLang = getNativeLanguage(state)?.code || '';

					const group = getUserGroupById(state, getActiveGroupId(state) || 0)
					if (group?.type === EUserGroupType.PREVIEW) {
						userTargetLang = getGroupTargetLanguage(state, group)?.code || '';
						userNativeLang = getGroupNativeLanguage(state, group)?.code || '';
					}

					let targetLangCode = userTargetLang;
					let nativeLangCode = userNativeLang;

					const videoLangCode = VideoMetaInfo.getVideoPriorityTargetLang(videoLangCodes, userTargetLang, videoInfo);

					if (videoLangCode && videoLangCode !== nativeLangCode) {
						targetLangCode = videoLangCode;
					}

					let groupName = createGroupNameIndex(state, newListName || `${LangUtil.getLangNameByCode(targetLangCode)} / ${LangUtil.getLangNameByCode(nativeLangCode)}`);

					groupId = await UserGroupEffects.createGroup(groupName, targetLangCode, nativeLangCode);

					if (groupId) {
						await UserGroupEffects.loadGroup(groupId);
					}
				}

				// @ts-ignore
				const result: TAddVideoResult = await dispatch(addVideoEffect(groupId, YoutubeUrlUtil.getUrlById(videoId), '', false));
				if (srcGroupId) {
					dispatch(await copyPhrasesRest(videoId, srcGroupId, groupId));
				}
				if (result && result.videoId) {
					Navigator.openVideo(groupId, videoId, 0, true);
					UserGroupEffects.setLibraryGroupId(groupId);

					if (srcGroupId) {
						const srcGroup = getUserGroupById(state, srcGroupId);
						if (srcGroup?.type === EUserGroupType.PREVIEW) {
							await dispatch(removeVideoFromGroup(videoId, srcGroupId));
						}
					}
				}
			} catch(e) {
				ErrorEffects.logError(e);
			}


			// new VideoCaptionsPunctuationCheckStarter(result.videoId, groupId).startWatch();

			setTimeout(() => { // show success
				dispatch(this.onClose());
			}, 2000);
			return Promise.resolve();
		}
	}

	public static onClose(): AppThunk {
		return (
			dispatch,
			getState
		) => {
			dispatch(setAddVideoConfirmAction({ show: false }));
		}
	}

	public static onLogin(): AppThunk {
		return async (
			dispatch,
			getState
		): Promise<boolean> => {
			EventsRouter.trackEvent(Events.SIGN_IN_CLICKED);
			const result = await AuthUserEffects.loginProcess(AuthUserEffects.newUserDefaultHandler, '', '', true);
			const ret = !!result && !!result.authUser;
			if (ret) {
				if (!result.authUser.isNew) {
					const {onLogin} = LoginPopupSelectors.getLoginPopup(getState());
					if (onLogin) {
						onLogin();
					} else {
						window.location.reload();
					}
				}
			}
			return ret;
		}
	}


}